import './About.css';

function About() {
  return (
    <section id="nosotros" className="about-section py-5">
      <div className="container">

        {/* Bloque de presentación con animación */}
        <div className="text-center animate-on-scroll">
          <h6 className="text-primary text-uppercase">SOBRE NOSOTROS</h6>
          <h2 className="fw-bold mb-4">Conoce a <span className="text-primary">Code Nest</span></h2>
          
          <p className="text-muted fs-5 w-75 mx-auto mb-4">
            Somos una empresa independiente con muchas ganas de crecer, avanzar y consolidarnos en el mundo del desarrollo tecnológico. 
            Amamos lo que hacemos y nos apasiona crear soluciones digitales que impactan, transforman y ayudan a los negocios a alcanzar su máximo potencial.
          </p>

          <p className="text-muted fs-5 w-75 mx-auto mb-4">
            Nos caracteriza el compromiso, la atención personalizada y el deseo constante de superarnos. 
            Trabajamos cada proyecto como si fuera propio, porque entendemos que detrás de cada idea hay un sueño que merece hacerse realidad.
          </p>

          <h3 className="fw-bold mt-5 text-primary">Your Vision, Our Code.</h3>
        </div>

      </div>
    </section>
  );
}

export default About;
